import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectReportsStore = ({ report }) => report;

const makeSelectUsedReport = () => createSelector(
  selectReportsStore,
  ({ usedReport }) => usedReport,
);

const makeSelectAvailableReports = () => createSelector(
  selectReportsStore,
  ({ availableReports }) => availableReports,
);

export {
  selectReportsStore,
  makeSelectUsedReport,
  makeSelectAvailableReports,
};
